import { ProductDataProps } from '@unlikelystudio/react-abstract-components'

import getAlternateUrl from '~/utils/alternate-url'

export default function serializeJSONLD({
  name,
  description,
  image,
  price,
  path,
  currency,
  sku,
  availability,
}): ProductDataProps {
  const date = new Date()
  const priceValidUntil = new Date(date.setMonth(date.getMonth() + 3))
    .toISOString()
    ?.split('T')[0]

  return {
    name: name ?? null,
    brand: {
      name: 'Herbarium',
    },
    description: description ?? null,
    sku: sku ?? null,
    image:
      image?.map((image) => {
        return image?.src
      }) ?? null,
    offers: {
      price: price ?? 0,
      priceCurrency: currency,
      priceValidUntil,
      url: getAlternateUrl(path),
      availability: availability
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock' ?? 'https://schema.org/InStock',
    },
  }
}
